import PortalIdParser from 'PortalIdParser';
import http from 'hub-http/clients/apiClient';
export const fetchJsonBlob = lookupKey => {
  return http.get(`trials/v1/json/${lookupKey}?portalId=${PortalIdParser.get()}`).then(response => {
    return response.jsonData;
  });
};
export const putJsonBlob = (lookupKey, jsonData) => {
  return http.put(`trials/v1/json`, {
    data: {
      lookupKey,
      jsonData
    }
  });
};